import React from "react";
import "./work.css";
import { Link } from "react-router-dom";

export default function Work() {
  return (
    <>
      <div className="mainWork " id="work">
      <h1
          className="intro"
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}>
          Work
        </h1>

        <div className="firstmain">
          
          <h1 className="projects">Project</h1>
          <div className="project">
            <h2>Real Time Chat App | April 2022 | <a href="https://chatapp0307.netlify.app/" target="_blank">Link</a> </h2>
            <p>
              ● In this project, I developed a backend server using NodeJS and
              ExpressJS, which handled user authentication and real-time
              communication using Socket.io.
            </p>
            <p>
              {" "}
              ● On the frontend, I used ReactJS and CSS to provide an intuitive
              and interactive user interface for the chat app.{" "}
            </p>
          </div>
          <div className="project">
            <h2>Netflix Clone | Jan 2023 | <a href="https://netflixclone0307.netlify.app/" target="_blank">Link</a></h2>
            <p>
              ● Throughout the project, I demonstrated a strong understanding of
              React JS concepts, such as component-based architecture and state
              management. I also showed proficiency in CSS, using responsive
              design techniques to ensure the Netflix clone looked and worked
              well across a range of devices.
            </p>
            <p>
              {" "}
              ● Additionally, I utilized the TMDb API to retrieve data about
              movies and TV shows, displaying this information in an intuitive
              and user-friendly manner.
            </p>
          </div>
          <div className="project">
            <h2>Portfolio | March 2022 |<a href="/" target="_blank">Link</a></h2>
            <p>
              ● In this project, I utilized my skills in HTML/CSS to create the
              basic structure and styling of the portfolio website.{" "}
            </p>
            <p>
              {" "}
              ● Additionally, I used React JS to add interactive components to
              the website, such as a navigation menu and a contact form.
            </p>
            <p>
              ● I also integrated Email.js to enable users to send me messages
              directly from the website.
            </p>
          </div>
          <div className="project">
            <h2>More Projects... |  <Link to='/projects'>Link</Link>  </h2>
         
          </div>
        </div>



        <div className="secondMain">
          <div className="blank"></div>
          <h1 className=" experience ">EXPERIENCE</h1>
          <div className="exp">
            <h2>Google Developer Student Club, GGV Bilaspur —Team Member</h2>
            <h4>April-2021 - Dec-2021 </h4>
            <h4>[ Member - Cloud/DevOps Club ] </h4>
          </div>

          <div className="exp">
            <h2>Equlibrio (Techinal Fest), GGV Bilaspur — Team Member</h2>
            <h4>JAN 2022 - PRESENT</h4>
            <h4>[ EventHead -Gaming Team ]</h4>
          </div>
        </div>

        
      </div>
    </>
  );
}
